import React from 'react';
import { Search } from 'lucide-react';
import clsx from 'clsx';

const SearchInputGroup = React.forwardRef(function SearchInputGroup(
  {
    value,
    onChange,
    onSubmit,
    onKeyDown,
    placeholder = 'Search businesses...',
    className,
    inputClassName,
    ...props
  },
  ref
) {
  const handleKeyDown = (e) => {
    onKeyDown?.(e);
    if (e.defaultPrevented) return;

    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit?.(String(value || '').trim());
    }
  };

  return (
    <div className={clsx('relative flex items-center', className)}>
      <Search
        className="pointer-events-none absolute left-3 h-4 w-4 text-[var(--text,#334155)] opacity-50"
        aria-hidden="true"
      />
      <input
        ref={ref}
        type="search"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className={clsx(
          'w-full rounded-xl border border-[var(--border,#CBD5E1)] bg-white py-2 pl-9 pr-3 text-sm',
          'text-[var(--text,#334155)] placeholder:text-[var(--muted,#94A3B8)]',
          'transition-colors focus:border-[var(--primary,#1D4ED8)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-soft,#DBEAFE)]',
          inputClassName
        )}
        {...props}
      />
    </div>
  );
});

export { SearchInputGroup };
export default SearchInputGroup;
